import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { colorSlate } from './color';
import { zHeroCarouselActive, zHeroCarouselInactive } from './z';
export const transitionQuickEase = '0.125s ease-in-out';

export const transitionGroupSlide = () => ({
  transitionAppearTimeout: 300,
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    appear: style({
      opacity: 0.01,
      transform: 'translate3d(20px, 0, 0)',
    }),
    appearActive: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
      transition: `all ${transitionQuickEase}`,
    }),
    enter: style({
      opacity: 0.01,
      transform: 'translate3d(20px, 0, 0)',
    }),
    enterActive: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
      transition: `all ${transitionQuickEase}`,
    }),
    leave: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
    }),
    leaveActive: style({
      opacity: 0.01,
      transform: 'translate3d(-20px, 0, 0)',
      transition: `all ${transitionQuickEase}`,
    }),
  },
});

export const transitionGroupCarousel = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`,
    }),
    leave: style({
      opacity: 1,
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`,
    }),
  },
});

export const transitionGroupHero = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 600,
  transitionName: {
    enter: style({
      opacity: 0.01,
      zIndex: zHeroCarouselActive,
    }),
    enterActive: style({
      opacity: 1,
      zIndex: zHeroCarouselActive,
      transition: `opacity ${transitionQuickEase}`,
    }),
    leave: style({
      opacity: 1,
      zIndex: zHeroCarouselInactive,
    }),
    leaveActive: style({
      opacity: 0.01,
      zIndex: zHeroCarouselInactive,
      transition: `opacity ${transitionQuickEase} 0.3s`,
    }),
  },
});

export const transitionModal = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)',
        },
      },
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
          transition: `transform ${transitionQuickEase}`,
        },
      },
    }),
    leave: style({
      opacity: 1,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
        },
      },
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)',
          transition: `transform ${transitionQuickEase}`,
        },
      },
    }),
  },
});

export const transitionDropDrawer = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
      $nest: {
        '&> div': {
          height: 'translate3d(0,-5px,0)',
        },
      },
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
          transition: `transform ${transitionQuickEase}`,
        },
      },
    }),
    leave: style({
      opacity: 1,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
        },
      },
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)',
          transition: `transform ${transitionQuickEase}`,
        },
      },
    }),
  },
});

export const transitionExpandFade = () => ({
  transitionEnterTimeout: 600,
  transitionLeaveTimeout: 600,
  transitionAppear: true,
  transitionAppearTimeout: 600,
  transitionName: {
    appear: style({
      maxHeight: 0,
      opacity: 0,
    }),
    appearActive: style({
      opacity: 1,
      maxHeight: '500px',
      transition: '0.5s max-height ease-in-out, 0.5s opacity ease-in-out',
    }),
    enter: style({
      maxHeight: 0,
      opacity: 0,
    }),
    enterActive: style({
      opacity: 1,
      maxHeight: '500px',
      transition: '0.5s max-height ease-in-out, 0.5s opacity ease-in-out',
    }),
    leave: style({
      opacity: 1,
      maxHeight: '500px',
    }),
    leaveActive: style({
      maxHeight: 0,
      opacity: 0,
      transition: '0.5s max-height ease-in-out, 0.5s opacity ease-in-out',
    }),
  },
});

export const transitionSlideFromBottom = () => ({
  transitionEnterTimeout: 500,
  transitionLeaveTimeout: 500,
  transitionName: {
    enter: style({
      backgroundColor: colorSlate.fade(0.01).toString(),
      $nest: {
        '&> section': {
          transform: 'translateY(100vw)',
        },
      },
    }),
    enterActive: style({
      backgroundColor: colorSlate.fade(0.7).toString(),
      transition: 'background-color 0.5s ease-in-out',
      $nest: {
        '&> section': {
          transition: 'transform 0.5s ease-in-out',
          transform: 'translateY(0)',
        },
      },
    }),
    leave: style({
      backgroundColor: colorSlate.fade(0.7).toString(),
      $nest: {
        '&> section': {
          transform: '0',
        },
      },
    }),
    leaveActive: style({
      backgroundColor: colorSlate.fade(0).toString(),
      transition: 'background-color 0.5s ease-in-out',
      $nest: {
        '&> section': {
          transition: 'transform 0.5s ease-in-out',
          transform: 'translateY(100vw)',
        },
      },
    }),
  },
});
